import { Component, Input } from '@angular/core';

import { CoreMenuItem } from '../../../../../types';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[xbaht-core-menu-vertical-item]',
  templateUrl: './item.component.html',
  styleUrl: './item.component.scss',
  standalone: false
})
export class CoreMenuVerticalItemComponent {
  @Input()
  public item!: CoreMenuItem;
}
